export default __webpack_public_path__ + "static/media/shiori-avatar-cutout.c68ae09c.png";